import { render, staticRenderFns } from "./CurrentNotes.vue?vue&type=template&id=63280286&scoped=true&"
import script from "./CurrentNotes.vue?vue&type=script&lang=js&"
export * from "./CurrentNotes.vue?vue&type=script&lang=js&"
import style0 from "./CurrentNotes.vue?vue&type=style&index=0&id=63280286&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63280286",
  null
  
)

export default component.exports